export default 1000;



/** WEBPACK FOOTER **
 ** ./src/api/delay.js
 **/